export const updateGenesysConnection = connectionState => {
  return {
    type: 'UPDATE_GENESYS_CONNECTION',
    connectionState,
  };
};
